import { filter } from "rxjs/operators";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CommonService } from "@app/_services";
import { EndpointService } from "@app/endpoint/endpoint.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "@environments/environment";
import { ScreenShotModalComponent } from "@app/_shared/screen-shot-modal/screen-shot-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MultiValidationModalComponent } from "./multi-validation-modal/multi-validation-modal.component";
import { OpenValueModalComponent } from "../open-value-modal/open-value-modal.component";
import { MobileConfigurationDetailsModalComponent } from "../mobile-configuration-details-modal/mobile-configuration-details-modal.component";
import { PlaywrightAutoselectLocatorModalComponent } from "@app/endpoint/webinstruction/playwright-autoselect-locator-modal/playwright-autoselect-locator-modal.component";
import { UserService } from "@app/user/user.service";
import { AutoselectLocatorModalComponent } from "@app/endpoint/webinstruction/autoselect-locator-modal/autoselect-locator-modal.component";
import { constants } from "@assets/data/constants";
import { MobileScreenShotModalComponent } from "../mobile-screen-shot-modal/mobile-screen-shot-modal.component";

@Component({
  selector: "app-results-endpoint",
  templateUrl: "./results-endpoint.component.html",
  styleUrls: ["./results-endpoint.component.less"],
})
export class ResultsEndpointComponent implements OnInit {
  @Input() selectedRetryAttempt: any;
  @Input() testCaseDetail: any;
  @Input() tcExecData: any;
  @Input() tCaseIndex: number;
  @Input() isExecResult = false;
  @Input() projectConfiguration: any;
  @Input() testCaseExecutionResult: any;
  @Input() selectedEndpointIndex = 0;
  @Output() updateSelectedEndpointIndex = new EventEmitter<any>();

  endPointResults: any = {};
  endPointExec: any = {};
  syncTestdata: any = [];
  testCaseResponseExtractor: any = [];
  validations: any = [];
  actionOnCondition: any = [];
  rulesList: any = [];
  domsRes: any = [];
  uiMeta: any;
  webInstActive: string;
  validationSearch: string;
  isImageCompareExists = false;
  userProjects: any;
  webLocatorsList : any = [];
  noSql: any;
  activeTabId: any = 0;

  /* UI flags */
  uiControls: any = {};
  showTestcaseResult = false;
  webResCollapsed = false;
  domCollapsed = false;
  collapseRequestBody = false;
  webInstructionExpandable = true;

  constructor(
    private CommonServices: CommonService,
    private EndpointServices: EndpointService,
    private Tostr: ToastrService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.getMyProjects();
    console.log("This is NG Init");
    this.uiMeta = JSON.parse(localStorage.getItem("about")).webAutomationMetaData;
    if(this.tcExecData?.endPointNoSqlIds.length > 0 && this.tcExecData?.downStreamWarning	===null) {
      this.readEPDetailFromNoSql(this.tcExecData.endPointNoSqlIds[this.selectedEndpointIndex], this.selectedEndpointIndex, false, this.selectedRetryAttempt );
    }
  }

  changeTab(event: any): void {
    if (event.nextId == "1") {
      this.getExecutedWebInstructionList();
    } else if (event.nextId == "2") {
      this.readSyncDataByNoSqlId();
    } else if (event.nextId == "3") {
      this.actionOnCondtionsResults(this.endPointResults.noSqlId);
    } else if (event.nextId == "4") {
      this.readValidationResultsByNoSqlId(this.endPointResults.noSqlId);
    }  else if (event.nextId == "5" || event.nextId == "6" || event.nextId == "7") {
      this.readRespExtractorByNoSqlId();
    }
  }

  setActiveTab() {
    if(this.endPointResults.mobileEndPoint || this.endPointResults.desktopEndPoint) {
      this.activeTabId = 0;
    } else if(this.endPointResults.webEndPoint) {
      this.activeTabId = 1;
      this.getExecutedWebInstructionList();
    } else {
      this.activeTabId = 10;
    }
  }

  readEPDetailFromNoSql(noSql: number, index: any, shouldUpdate: any, testCaseRetryAttempt?: any): void {
    this.noSql = noSql;
    this.domsRes = [];
    this.webResCollapsed = false;
    this.showTestcaseResult = true;
    if(shouldUpdate) {
      this.updateSelectedEndpointIndex.emit(index);
    }
    this.CommonServices.readEndPointResultsFromNoSqlTestdataOrder(noSql, this.tcExecData.testDataSetOrder, testCaseRetryAttempt).subscribe(
      (data) => {
        this.setUiControls();
        this.endPointResults = data.response;
        this.endPointExec = this.endPointResults.endPointExecution[this.tCaseIndex];
        this.setActiveTab();
        if (this.endPointExec !== undefined && this.endPointExec?.responseBody != null) {
          if (this.endPointExec.responseType === "JSON" || this.endPointExec.responseType === "XML") {
            this.endPointExec.responseBody = this.endPointExec.responseBody;
          } else {
            this.endPointExec.responseBody = JSON.stringify(this.endPointExec.responseBody);
          }
        }
        if (this.endPointExec !== undefined && this.endPointExec.requestBody && (this.endPointExec.responseType === "JSON" || this.endPointExec.responseType === "XML")) {
          this.endPointExec.requestBody = JSON.parse(this.endPointExec.requestBody);
        }
        if (this.isExecResult) {
          this.readValidationResultsByNoSqlId(this.endPointResults.nosqlId);
          this.readSyncDataByNoSqlId();
          this.readRespExtractorByNoSqlId();
        }
      },
      (err) => {
        this.Tostr.error(err.error.message);
      }
    );
  }

  getExecutedWebInstructionList() {
    this.CommonServices.getExecutedWebInstructionList(this.noSql, this.tcExecData.testDataSetOrder).subscribe(
      (data) => {
        if(this.projectConfiguration !== 'PLAYWRIGHT') {
          this.endPointExec.webInstructions = data.response;
        } else {
          this.endPointExec.pwWebInstructions = data.response;
        }
      },
      (err) => {
        this.Tostr.error(err.error.message);
      }
    );
  }

  fileDownload(gridFsId: string): void {
    window.open(environment.apiUrl + "file/download/" + gridFsId);
  }

  viewImage(validation, ViewFileName?: string) {
    const modalInstance = this.modalService.open(MobileScreenShotModalComponent, { size: 'lg', centered: true });
    let name: string | undefined;
    let gridFsId: string | undefined;

    switch (ViewFileName) {
      case "imageCompareResultFile":
        name = validation.imageCompareResultFile?.fileName;
        gridFsId = validation.imageCompareResultFile?.gridFsId;
        break;
      case "pwDomExtractedValue":
        name = validation?.extractedValue;
        gridFsId = validation?.extractedValue;
        break;
      case "domExtractedValue":
        name = validation.domExtractor?.displayValue + '.png';
        gridFsId = validation.domExtractor?.extractedValue;
        break;
      case "expectedFileName":
        name = validation.expected?.fileName;
        gridFsId = validation.expected?.gridFsId;
        break;
      case "expectedResponseExtractor":
        name = validation.expected?.value || validation.expected.responseExtractor?.displayValue;
        gridFsId = validation.expected.responseExtractor?.extractedValue;
        break;
      default:
        name = validation?.displayValue;
        gridFsId = validation?.extractedValue;
        break;
    }

    modalInstance.componentInstance.hideExportButton = true;
    modalInstance.componentInstance.mobileInstructionDetails = { name };
    modalInstance.componentInstance.gridFsId = gridFsId;
    modalInstance.componentInstance.gridFsName = name;
  }

  viewDomImageFile(validation, ViewFileName?: string) {
    const modalInstance = this.modalService.open(MobileScreenShotModalComponent, { size: 'lg', centered: true });
    let name: string | undefined;

    switch (ViewFileName) {
      case "downloadedFileName":
        name = validation.actual?.downloadedFileName || validation.actual?.displayName;
        break;
      case "domExtractor":
        name = validation.actual?.domExtractor?.displayValue;
        break;
      default:
        name = validation.actual?.displayValue;
        break;
    }
    modalInstance.componentInstance.hideExportButton = true;
    modalInstance.componentInstance.gridFsId = validation.actual?.extractedValue;
    modalInstance.componentInstance.mobileInstructionDetails = { name };
    modalInstance.componentInstance.gridFsName = name;
  }

  getInovice(invoiceNo: string): void {
    this.CommonServices.getHostName().subscribe((data) => {
      const invoiceUrl = "//" + data.response.relayExecutorHostName + "/relay-executor-api/q2c/invoicePdf/download?invoiceNumber=" + invoiceNo;
      window.open(invoiceUrl, "_blank");
    });
  }

  actionOnCondtionsResults(noSqlId: string) {
    if (!this.uiControls.collapseValidationActionCond) {
      this.uiControls.collapseValidationActionCond = true;
      return;
    }
    this.CommonServices.actionOnCondtionsResults(noSqlId, this.tCaseIndex).subscribe(
      (data) => {
        if (data.code === 200) {
          this.rulesList = data.response;
        } else {
          this.rulesList = [];
        }
      },
      (err) => {
        this.Tostr.error(err.error.message);
        this.rulesList = [];
      },
      () => {
        this.uiControls.collapseValidationActionCond = false;
      }
    );
  }

  readValidationResultsByNoSqlId(noSqlId: string): void {
    if (!this.uiControls.collapseValidationResults) {
      this.uiControls.collapseValidationResults = true;
      return;
    }
    this.CommonServices.readValidationResultsByNoSqlId(noSqlId, this.tCaseIndex).subscribe(
      (data) => {
        this.validations = data.response;
        this.isImageCompareProperty(data.response);
      },
      (err) => {
        this.Tostr.error(err.error.message);
        this.validations = [];
      },
      () => {
        this.uiControls.collapseValidationResults = false;
      }
    );
  }
  isImageCompareProperty(data: any[]) {
    const propertyName = 'condition';
    const imgCompare = 'IMAGE_COMPARE';

    this.isImageCompareExists = data.some(item => item[propertyName] === imgCompare);
  }

  filterValidation(name: string, status: string) {
    if (name === "" && status === "") {
      return;
    }
    // this.validations;
  }

  getMultipleValidationRes(expectedObj: any, actualObj: any): void {
    const modalRef = this.modalService.open(MultiValidationModalComponent, { size: "xl" });
    modalRef.componentInstance.expectedObj = expectedObj;
    modalRef.componentInstance.actualObj = actualObj;
  }

  /* read test case --> endpoint --> sync data by nosqlId */
  readSyncDataByNoSqlId(): void {
    if (this.uiControls.collapseSyncTestData === false) {
      this.uiControls.collapseSyncTestData = true;
      return;
    }
    this.CommonServices.readSyncDataByNoSqlId(this.endPointResults.noSqlId, this.tCaseIndex).subscribe(
      (data) => {
        this.syncTestdata = data.response;
        this.syncTestdata.sort((a, b) => a.keySequence - b.keySequence);
      },
      (err) => {
        this.Tostr.error(err.error.message);
      },
      () => {
        this.uiControls.collapseSyncTestData = false;
      }
    );
  }

  readRespExtractorByNoSqlId(): void {
    if (this.uiControls.collapseSyncExtractor === false) {
      this.uiControls.collapseSyncExtractor = true;
      return;
    }
    this.CommonServices.readRespExtractorByNoSqlId(this.endPointResults.noSqlId, this.tCaseIndex).subscribe(
      (data) => {
        if (data.code === 200) {
          this.testCaseResponseExtractor = data.response;
          for(let i=0; i< this.testCaseResponseExtractor.length; i++ ) {
            this.testCaseResponseExtractor[i].showFormattedCode = false;
          }
        } else if (data.code === 204) {
          this.testCaseResponseExtractor = [];
        }
      },
      (err) => {
        this.Tostr.error(err.error.msg);
      },
      () => {
        this.uiControls.collapseSyncExtractor = false;
      }
    );
  }

  getResDomExtra(noSqlId: string): void {
    this.EndpointServices.getResDomExtra(noSqlId).subscribe(
      (data) => {
        if (data.code === 200) {
          this.domsRes = data.response;
        } else if (data.code === 204) {
          this.domsRes = [];
        }
      },
      (err) => {
        this.Tostr.error(err.error.message);
      },
      () => {
        this.webInstActive = noSqlId;
        this.webResCollapsed = !this.webResCollapsed;
      }
    );
  }

  openScreenShotModal(webInstructions: any, index: number): void {
    const modalInstance = this.modalService.open(ScreenShotModalComponent, { size: "lg" });
    modalInstance.componentInstance.endPointResults = this.endPointResults;
    modalInstance.componentInstance.webInstructions = webInstructions;
    modalInstance.componentInstance.index = index;
  }

  setUiControls(): void {
    let resultBool = true;
    if (this.isExecResult) {
      resultBool = false;
    }
    this.uiControls.collapseSyncTestData = resultBool;
    this.uiControls.collapseSyncExtractor = resultBool;
    this.uiControls.collapseValidationResults = resultBool;
    this.uiControls.collapseValidationActionCond = resultBool;
  }

  openValueModal(item: any, key?: any) {
    const modalRef = this.modalService.open(OpenValueModalComponent, {
      ariaLabelledBy: "modal-basic-title",
      backdrop: true,
      windowClass: "confirm-modal",
      size: "lg",
    });
    modalRef.componentInstance.value = item;
    modalRef.componentInstance.key = key;
  }

  openMobileConfigurationDialog() {
    const modalRef = this.modalService.open(
      MobileConfigurationDetailsModalComponent,
      {
        ariaLabelledBy: "modal-basic-title",
        backdrop: true,
        centered: true,
        size: "lg",
      }
    );

    modalRef.componentInstance.mobileEnvironmentDetails = JSON.parse(this.endPointResults.environment.mobileConfiguration);
    modalRef.componentInstance.mostRecentExecuted = this.endPointResults;
  }

  showMobileTCVideo(testCaseExecutionId) {
    if (this.testCaseDetail.mobileTestCase) {
      window.open(
        `${environment.apiUrl}video/streamVideo?platform=mobile&fileName=${testCaseExecutionId}.mp4`
      );
    } else if (this.testCaseDetail.desktopTestCase) {
      window.open(
        `${environment.apiUrl}video/streamVideo?platform=desktop&fileName=${testCaseExecutionId}.mp4`
      );
    }
  }


  showPwVideo(testCaseExecutionId, endpointExecutionId) {
    window.open(
      `${environment.apiUrl}video/stream/${testCaseExecutionId}/${endpointExecutionId}`
    );
  }

  editWebInstruction(data: any, fieldName: any) {
    this.getWebLocatorList().then(() => {
      const locatorModalRef = this.modalService.open(AutoselectLocatorModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        windowClass: 'confirm-modal',
        centered: true,
        size: 'xl'
      });
      if (fieldName === constants.fieldNameLocator) {
        locatorModalRef.componentInstance.editAutoSelectedLoc = data;
      }
      locatorModalRef.componentInstance.uiMeta = this.uiMeta;
      locatorModalRef.componentInstance.fieldName = fieldName;
      locatorModalRef.componentInstance.endPointDetails = this.testCaseDetail;
      locatorModalRef.componentInstance.webLocatorsList = this.webLocatorsList;
      locatorModalRef.componentInstance.userProjects = this.userProjects;
      locatorModalRef.componentInstance.baseLocator = false;
      locatorModalRef.componentInstance.edited = true;
      locatorModalRef.componentInstance.selectedLocator.subscribe((webLoc: any) => {
        // this.getInstructions(this.endpointDetails.id);
      });

      // locatorModalRef.componentInstance.modalClosed.subscribe(() => { this.refreshLocator(); });
    }).catch(errorMessage => this.toastr.error(errorMessage));
  }

  getWebLocatorList(search?): Promise<any> {
    this.webLocatorsList = [];
    let params = {
      projectIds: this.testCaseDetail.project.id,
      locatorType: null,
      locatorString: null,
      componentTypes: null,
      useJquery: null,
      name: null,
      size: 10,
      useSuperAdminPrivileage: false,
    };
    if (search) {
      params = Object.assign({}, params, search);
    }

    return new Promise((resolve, reject) => {
      this.EndpointServices.getWebLocatorsList(params).subscribe((data) => {
        if (data.code === 200) {
          this.webLocatorsList = data.response;
          resolve(data.response);
        } else if (data.code === 204) {
          this.webLocatorsList = [];
          resolve([]);
        } else {
          reject(data.message);
        }
      });
    });
  }

  editPwWebInstruction(data: any, fieldName: any) {
    const locatorModalRef = this.modalService.open(PlaywrightAutoselectLocatorModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      windowClass: 'confirm-modal',
      centered: true,
      size: 'xl'
    });
    locatorModalRef.componentInstance.uiMeta = this.uiMeta;
    locatorModalRef.componentInstance.fieldName = fieldName;
    locatorModalRef.componentInstance.endPointDetails = this.testCaseDetail;
    locatorModalRef.componentInstance.userProjects = this.userProjects;
    locatorModalRef.componentInstance.editAutoSelectedLoc = data;
    locatorModalRef.componentInstance.baseLocator = false;
  }

  getMyProjects() {
    this.userService
      .getMyProjectList()
      .pipe()
      .subscribe((data) => {
        if (data.code === 200) {
          this.userProjects = data.response;
        } else {
          this.toastr.error(data.message);
        }
      });
  }

  formatAll(event: any) {
    for(let i=0; i< this.testCaseResponseExtractor.length; i++ ) {
      this.testCaseResponseExtractor[i].showFormattedCode = event.target.checked;
    }
  }

  getResponseExtractorById(responseExtractor: any, index : any) {
    this.CommonServices.getResponseExtractorById(responseExtractor.noSqlId).subscribe(
      (data : any) => {
        this.testCaseResponseExtractor[index] = data.response;
        this.testCaseResponseExtractor[index].lazy = false;
      },
      (err) => {
        this.Tostr.error(err.error.message);
      }
    );
  }

  lazyLoadResponseBody(endPointId: any) {
    this.EndpointServices.lazyLoadResponseBody(endPointId).pipe().subscribe(data => {
      if (data.code === 200) {
        if(this.endPointExec.responseType ==='JSON' || this.endPointExec.responseType ==='XML' || this.endPointExec.responseType === 'EVENT_STREAM') {
          this.endPointExec.responseBody = JSON.parse(data.response.responseBody);
        } else {
          this.endPointExec.responseBody = data.response.responseBody;
        }
        this.endPointExec.lazy = false;
      } else {
        this.toastr.error(data.message);
      }
    });
  }
}
